import LanguageSelection from "./LanguageSelection";



function EmbassyDetails(props) {
  const { values } = props;
  const {
    configuration
  } = values;


  const { isParmEmbassyCode,selectedEmbassyCode } = values;

  const {
    isAttestationService
  } = configuration;
  
  return (
    <div className="row">
      <div className="col-sm-12 col-lg-3 d-none d-lg-block">&nbsp;</div>
      <div className="col-sm-12 col-lg-9">
        <div className="row mt-4">

          
          <div className="col-6">
          {isParmEmbassyCode &&  <div className="col-6">            
            <a href={(selectedEmbassyCode.toLowerCase())}><img src="images/emx-logo.svg" alt="EMX" className="main-logo" /></a>
          </div>}
          {!isParmEmbassyCode &&  <div className="col-6">            
            <a href="/embassy"><img src="images/emx-logo.svg" alt="EMX" className="main-logo" /></a>
          </div>}
          </div>
          <div className="col-6 align-self-center">
            <div className="d-block d-md-none">
              <LanguageSelection  {...props}  />
            </div>
          </div>
        </div>
        <div className="row align-items-center mt-5 embassy-logo">
         

          <div className="col-sm-12 mt-3">
            <img
              src={"data:image/jpeg;base64, " + values.embassyLogo}
              alt="Embassy Logo"
              className="embassy-logo-inner"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmbassyDetails;
